module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp123_8023.fd6eaa02.png";